(() => {
const $4c576e06fe3b67c5$var$FETCH_TIMEOUT_MS = 8000;
const $4c576e06fe3b67c5$var$fetchJson = (url)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), $4c576e06fe3b67c5$var$FETCH_TIMEOUT_MS);
    return fetch(url, {
        signal: controller.signal
    }).then((response)=>response.ok ? response.json() : null).catch(()=>null).finally(()=>clearTimeout(timeoutId));
};
const $4c576e06fe3b67c5$var$markOptionUnavailable = (option)=>{
    const template = window.variantStrings?.unavailable_with_option;
    if (!template) return;
    option.textContent = template.replace("[value]", option.textContent?.trim() ?? "");
};
const $4c576e06fe3b67c5$var$checkDropdownOptions = async (variantSelects)=>{
    const productUrl = variantSelects.dataset.url;
    const variantsScript = variantSelects.querySelector('script[type="application/json"]');
    if (!productUrl || !variantsScript?.textContent) return;
    // Only single-option products: a dropdown option's value maps 1:1 to a
    // variant then. With more than one option, a value like "Large" could
    // match several variants (crossed with Color etc.), so QFC availability
    // can't be attributed to a single <option> without knowing the rest of
    // the picked combination.
    const selects = variantSelects.querySelectorAll("select.select__select");
    if (selects.length !== 1) return;
    let variants;
    try {
        variants = JSON.parse(variantsScript.textContent);
    } catch  {
        return;
    }
    const options = Array.from(selects[0].options).filter((option)=>option.value !== "");
    await Promise.all(options.map(async (option)=>{
        const variant = variants.find((v)=>v.option1 === option.value);
        // Already shown as unavailable via the Shopify-stock check; nothing to add.
        if (!variant || !variant.available) return;
        const url = `${productUrl}?variant=${variant.id}&view=qfc-availability`;
        const availability = await $4c576e06fe3b67c5$var$fetchJson(url);
        if (availability && !availability.isVariantAvailable) $4c576e06fe3b67c5$var$markOptionUnavailable(option);
    }));
};
document.querySelectorAll("variant-selects").forEach((variantSelects)=>{
    $4c576e06fe3b67c5$var$checkDropdownOptions(variantSelects);
});

})();
//# sourceMappingURL=productVariantQfcAvailability.js.map
